




















import {
  Component, Vue, PropSync, Prop,
} from 'vue-property-decorator';
import Overlay from '@/components/Overlay/index.vue';
import Textfield from '@/components/Form/Textfield/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import TextButton from '@/components/Buttons/TextButton/index.vue';
import Format from '@/util/Format';

@Component({
  components: {
    Overlay,
    Textfield,
    PrimaryButton,
    TextButton,
  },
})
export default class ReviewComments extends Vue {
  @PropSync('dialog', {}) dialogSync!: boolean;

  @PropSync('notes', {}) doc!: string;

  public close() {
    this.$emit('cancel');
  }

  public getDocumentFormat(date: string) {
    return Format.getFomattedDate(date);
  }
}
